/* tslint:disable */
/* eslint-disable */
/**
 * openapi.yml
 * オンラインCE API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AvailableCoefficientSetList,
  PostLoginRequest,
} from '../models/index';
import {
    AvailableCoefficientSetListFromJSON,
    AvailableCoefficientSetListToJSON,
    PostLoginRequestFromJSON,
    PostLoginRequestToJSON,
} from '../models/index';

export interface PostAvailableCoefficientSetRequest {
    postLoginRequest?: PostLoginRequest;
}

/**
 * 
 */
export class CoefficientApi extends runtime.BaseAPI {

    /**
     * 
     * 利用可能係数セットを取得する
     */
    async postAvailableCoefficientSetRaw(requestParameters: PostAvailableCoefficientSetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AvailableCoefficientSetList>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/coefficient`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PostLoginRequestToJSON(requestParameters['postLoginRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AvailableCoefficientSetListFromJSON(jsonValue));
    }

    /**
     * 
     * 利用可能係数セットを取得する
     */
    async postAvailableCoefficientSet(requestParameters: PostAvailableCoefficientSetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AvailableCoefficientSetList> {
        const response = await this.postAvailableCoefficientSetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
